import { useNavigationGuardStore } from '../store/navigation-guard.store';

/**
 * This composable is an utility used to disable the navigation guard at the end of a flow with steps
 */

export const useDisableNavigationGuard = () => {
  const navigationGuardStore = useNavigationGuardStore();

  const disableGuard = () => navigationGuardStore.setIsBlocked(false);

  return {
    disableGuard,
  };
};
